/**
 * Keeps the read-only freight statistics profiles (FRET_STATISTIC,
 * GLOBAL_FRET_STATISTIC) out of the freight writing screens, even through a
 * direct URL: they only filter and export the lists.
 */

import { Navigate } from 'react-router-dom';

import { useFreightAccess } from '../../hooks/useFreightAccess';

interface FreightWriteGuardProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export function FreightWriteGuard({
  children,
  redirectTo = '/dashboard/freight/list',
}: FreightWriteGuardProps) {
  const { isReadOnly } = useFreightAccess();
  if (isReadOnly) {
    return <Navigate to={redirectTo} replace />;
  }
  return <>{children}</>;
}
